export default __webpack_public_path__ + "static/media/videoplayerloading1.f63acdd5.jpg";